import { NgModule } from '@angular/core';
import { AuthApi } from './services/auth.api';
import { SettingsApi } from './services/projects/settings.api';
import { ProjectsApi } from './services/projects/projects.api';

@NgModule({
  imports: [],
  providers: [AuthApi, ProjectsApi, SettingsApi],
  exports: [],
})
export class ApiModule {}
